// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const MenuInactiveInactive: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 27 20"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="27" height="20"
            fill="currentColor"
        >
            <path
                d="M636.416667,185.111111 L612.583333,185.111111 C611.985025,185.111111 611.5,184.61365 611.5,184 C611.5,183.38635 611.985025,182.888889 612.583333,182.888889 L636.416667,182.888889 C637.014975,182.888889 637.5,183.38635 637.5,184 C637.5,184.61365 637.014975,185.111111 636.416667,185.111111 Z M628.475833,176.222222 L612.583333,176.222222 C611.985025,176.222222 611.5,175.724761 611.5,175.111111 C611.5,174.497461 611.985025,174 612.583333,174 L628.475833,174 C629.074142,174 629.559167,174.497461 629.559167,175.111111 C629.559167,175.724761 629.074142,176.222222 628.475833,176.222222 Z M633.2425,194 L612.583333,194 C611.985025,194 611.5,193.502539 611.5,192.888889 C611.5,192.275239 611.985025,191.777778 612.583333,191.777778 L633.2425,191.777778 C633.840808,191.777778 634.325833,192.275239 634.325833,192.888889 C634.325833,193.502539 633.840808,194 633.2425,194 Z"
                transform="translate(-611 -174)"
            />
        </svg>
    );
};

export default React.memo(MenuInactiveInactive);
